module.exports = __webpack_public_path__ + "img/download.2c83c521.svg";